import React, { useEffect } from 'react'
import Header from '../../headerone/Main'
import Bredcom from '../../Bredcom/Main'
import EmploymentWorkforceDetails from '../mendepartmentdetails/EmploymentWorkforce'


function EmploymentWorkforce() {

  useEffect(() => {
    document.getElementById("title").innerHTML="Employment and Workforce Development || State of GTS";
  }, [])


  return (
    <>
        {/* Header is now rendered at app level in routes/index.js to prevent remounting on navigation */}

        <div className="page-wrapper">
        <Bredcom 
            subtitle="home"
            title="Employment Workforce"
            subtitledown="Department of Employment & Workforce Development"
           />
            <EmploymentWorkforceDetails/>
        </div>
    </>
  )
}

export default EmploymentWorkforce